import { useNavigate } from "react-router-dom";
import { AppRoutings } from "utility/enums/app-routings";
import { Constants } from "utility/enums/constants";

export const OptInCheckBoxLabel = () => {
  // Page level local variables
  const navigate = useNavigate();

  // handle events
  const handleOpenTermsAndCondition = () => {
    navigate(AppRoutings.TermsAndConditions);
  };
  return (
    <>
      By checking this box, I agree to receive SMS messages about customer care,
      notifications, and marketing from Doctors to You at the phone number
      provided above. The SMS frequency may vary. Data rates may apply. Text
      HELP to (+1 202-568-6845) for assistance. Reply STOP to opt out of
      receiving SMS messages. To learn more please visit our Privacy Policy page
      at{" "}
      <a className="hyper-link" href="https://doctorstoyou.com/privacy-policy">
        https://doctorstoyou.com/privacy-policy
      </a>{" "}
      and our Terms and Conditions page at{" "}
      <a
        onClick={handleOpenTermsAndCondition}
        className="hyper-link"
        // href={
        //   Constants.TermsAndConditionPDFPath.toString() +
        //   "?v=" +
        //   new Date().getTime()
        // }
        // target="_blank"
      >
        https://DoctorstoYou.Terms&Conditions
      </a>
    </>
  );
};
